import { Search } from '@mui/icons-material';
import clsx from 'clsx';
import Image from 'next/image';
import { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { useDebounceValue } from 'hooks/useDebounceValue';
import { ImageFallbackStatic } from 'utils/ImageFallback';

interface Props {
  background?: string;
  title?: string;
  className?: string;
}

export const SectionSearch = ({ className, title, background = 'linear-gradient(180deg, #E52E2E 0%, #D74C1E 50%, #E77300 100%)' }: Props) => {
  return (
    <Controller
      name="search"
      render={({ field: { value, onChange } }) => {
        const [field, setField] = useDebounceValue(value, 1000);

        useEffect(() => {
          onChange(field);
        }, [field]);

        return (
          <div
            className={clsx('w-full py-[15px] px-5 flex justify-center rounded flex-col space-y-5 bg-white', className)}
            style={{
              background,
            }}
          >
            {title && <div dangerouslySetInnerHTML={{ __html: title }} />}
            {!title && (
              <div className="flex gap-3 items-center justify-center">
                <Image src="/icons/icon-money-1.svg" width={40} height={40} objectFit="contain" />
                <h2 className="text-[28px] font-medium text-white text-center">Sản phẩm áp dụng khuyến mãi</h2>
              </div>
            )}
            <div className="bg-white rounded-[8px] py-[10px] px-3 flex space-x-1">
              <Search />
              <input
                track-input-search=""
                refer-data-root-voucher="code"
                type="text"
                placeholder="Tìm kiếm sản phẩm"
                className="outline-none border-none flex flex-1"
                defaultValue={value}
                onChange={(e) => setField(e.target.value)}
              />
            </div>
          </div>
        );
      }}
    />
  );
};

